<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="horario" titulo="Horario / Docente" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">

  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- formulario -->
      <form name="form" novalidate>
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <nav class="level">
              <!-- Left side -->
              <div class="level-left">
                <div class="level-item">
                  <p class="title">
                    <span *ngIf="!cargando" class="icon is-medium">
                      <i class="icon-clock4"></i>
                    </span>
                    <span *ngIf="cargando" class="icon is-medium">
                      <i class="icon-worldwide fa-spin"></i>
                    </span>
                    <span class="icon is-medium">
                      <i class="fa icon-edit-1"></i>
                    </span> Horarios Docentes
                  </p>
                </div>

              </div>

              <!-- Right side -->
              <div class="level-right">
                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                  <span class="icon fa-2x">
                    <i class="icon-back"> </i>
                  </span>
                  <span class="tooltiptext">Regresar</span>
                </a>


                <a class="navbar-item tooltip" (click)="generarPDF()">
                  <span class="icon fa-2x">
                    <i class="icon-printer2"></i>
                  </span>
                  <span class="tooltiptext">Imprimir</span>
                </a>
              </div>
            </nav>

          </div>
        </section>

        <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;">
          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo', '', 'cargando_periodo'); ctrl.cargarCatalogo('profesores_horarios', 'empleado?id=2', '', 'cargando_profesor'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>

          <a id="imprimir_local" (click)="generarPDF(); "></a>
          <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
          <div class="columns">
            <div class="column is-2">
              <label class="label">Período activos:</label>
              <div class="control has-icons-left has-icons-right">
                <div class="b-checkbox is-info text-success">
                  <input name="activos" id="activos" [(ngModel)]="activos" (change)="seleccionarActivos($event)" class="styled" type="checkbox" [checked]="activos">
                  <label for="activos">
                    Todos
                  </label>
                </div>
              </div>
            </div>
            <div class="column is-5">
              <label class="label">Período escolar:</label>
              <div class="control has-icons-left has-icons-right">

                <span class="icon is-small is-left">
                  <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                </span>

                <ng-select2 [disabled]="activos ? true : ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true" [options]="ctrl.optionSelect" (valueChanged)="seleccionarPeriodo($event);" [data]="ctrl.periodos_escolares"></ng-select2>
              </div>
            </div>

            <div class="column is-5">
              <label class="label">Seleccione el docente:</label>
              <div class="control has-icons-left has-icons-right">
                <span class="icon is-small is-left">
                  <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_profesor"></i>
                </span>

                <ng-select2 [disabled]="ctrl.profesores_horarios ? ctrl.profesores_horarios.length == 0 ? true : false : true" [options]="ctrl.optionSelect" (valueChanged)="seleccionarProfesor($event);"
                  [data]="ctrl.profesores_horarios"></ng-select2>
              </div>
            </div>
          </div>

          <div *ngIf="profesorhorario" class="content">
            <div *ngFor="let modalidad of ph_modalidades">
              <div *ngFor="let modulo of ph_modulos[modalidad]; let i = index">
                <div class="box" *ngIf="ph_modalidades_dias[modalidad] > 2">
                  <article class="media">
                    <div class="media-left">
                      <figure class="image is-64x64">
                        <img src="{{API_PATH}}/adjunto/configuracion/{{configuracion.sucursal.logo != '' ? configuracion.sucursal.logo : configuracion.empresa.logo}}">
                      </figure>
                    </div>
                    <div class="media-content">
                      <div class="content" align="center">
                        <h3>{{configuracion.empresa.nombre}}</h3>
                        <h4>{{configuracion.sucursal.nombre}}</h4>

                        <p>DOCENTE: {{profesorhorario.docente.nombre}}</p>

                      </div>
                    </div>
                  </article>
                </div>

                <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" id="tabla{{i}}">
                  <caption><strong>MÓDULO: del {{modulo}}</strong></caption>
                  <thead>
                    <tr>
                      <th width="10%">Hora/Día</th>
                      <th width="18%" *ngFor="let dia of ph_dias[modalidad]">{{dias_semanas[dia]}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let hora of ph_horas[modalidad]">
                      <td>
                        <div>{{hora.split('-')[0]}}</div>
                        <div>{{hora.split('-')[1]}}</div>
                      </td>
                      <td *ngFor="let dia of ph_dias[modalidad]" width="{{88/ph_dias.length}}%" >
                        <div *ngIf="profesorhorario.horario[modalidad][modulo][dia]" align="center">
                          <div>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.nombre}}</div>
                          <small>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.clave}} {{profesorhorario.horario[modalidad][modulo][dia][hora]?.nivel}} {{profesorhorario.horario[modalidad][modulo][dia][hora]?.identificador}}</small>
                          <div>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.grupo}}</div>
                          <small>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.turno}}</small>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>

              <div *ngIf="ph_modalidades_dias[modalidad] <= 2" >
                <div class="box">
                  <article class="media">
                    <div class="media-left">
                      <figure class="image is-64x64">
                        <img src="{{API_PATH}}/adjunto/configuracion/{{configuracion.sucursal.logo != '' ? configuracion.sucursal.logo : configuracion.empresa.logo}}">
                      </figure>
                    </div>
                    <div class="media-content">
                      <div class="content" align="center">
                        <h3>{{configuracion.empresa.nombre}}</h3>
                        <h4>{{configuracion.sucursal.nombre}}</h4>

                        <p>DOCENTE: {{profesorhorario.docente.nombre}}</p>

                      </div>
                    </div>
                  </article>
                </div>

                <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" *ngFor="let dia of ph_dias[modalidad]">
                  <thead>
                    <tr>
                      <th><h2 align="center">{{dias_semanas[dia]}}</h2></th>
                    </tr>
                  </thead>
                  <tbody>
                    <td>
                      <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" id="tabla{{i}}">
                        <thead>
                          <tr>
                            <th width="200">Hora/Modulo</th>
                            <th *ngFor="let modulo of ph_modulos[modalidad]; let i = index" >{{modulo}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let hora of ph_horas[modalidad]">
                            <td>
                              <div>{{hora.split('-')[0]}}</div>
                              <div>{{hora.split('-')[1]}}</div>
                            </td>
                            <td *ngFor="let modulo of ph_modulos[modalidad]; let i = index" width="{{88/ph_dias.length}}%">
                              <div *ngIf="profesorhorario.horario[modalidad][modulo][dia]" align="center">
                                <div>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.nombre}}</div>
                                <small>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.clave}}</small>
                                <div>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.grupo}}</div>
                                <small>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.turno}}</small>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</div>
